import { Component } from '@angular/core';

@Component({
    selector: 'app-full',
    templateUrl: './full.component.html',
    standalone: false
})
export class FullComponent  {

  constructor() { }

  

}
